import { buildDemoStudentsForClass } from "./buildDemoStudents";

/** Alinhado à turma demo; GET /occurrences só envia idTurmaDisc (sem classId). */
export const DEMO_TURMA_DISC = 88001;
/** Disciplinas extra na lista (sem acesso à grade na demo). */
export const DEMO_TURMA_DISC_MAT = 88002;
export const DEMO_TURMA_DISC_CI = 88003;
export const DEMO_TURMA_DISC_HIST = 88004;
/**
 * Pseudo-disciplina usada como chave para o template "RELATÓRIO DE HABILIDADES"
 * (Educação Infantil — BNCC). Aparece no seletor do Relatório Individual com
 * `teacherAccess: true`; a lista de eixos/habilidades e a paleta C/CO/AC/NA
 * vêm de `buildDemoHabilidadesReport.js`.
 */
export const DEMO_TURMA_DISC_HAB = 88010;
const DEMO_SCHEDULE_ID_MORNING = 5001;
const DEMO_SCHEDULE_ID_AFTERNOON = 5002;

/**
 * Horários para o dropdown "Aulas" (mesmo contrato que getScheduleForOccurrences no waybee-api).
 * @param {string} classId
 */
export function buildDemoOccurrenceSchedule(classId) {
  if (classId !== "DEMO-T1") {
    return [];
  }
  const d = new Date();
  const dateStr = d.toISOString().split("T")[0];
  return [
    {
      id: 0,
      scheduleId: DEMO_SCHEDULE_ID_MORNING,
      name: "Português — demonstração (manhã)",
      date: dateStr,
      startTime: "08:00",
      EndTime: "09:00",
      idTurmaDisc: DEMO_TURMA_DISC,
      codDisc: "DEMO",
      idPerLet: d.getFullYear(),
      weekDay: d.getDay()
    },
    {
      id: 1,
      scheduleId: DEMO_SCHEDULE_ID_AFTERNOON,
      name: "Português — demonstração (tarde)",
      date: dateStr,
      startTime: "14:00",
      EndTime: "15:00",
      idTurmaDisc: DEMO_TURMA_DISC,
      codDisc: "DEMO",
      idPerLet: d.getFullYear(),
      weekDay: d.getDay()
    }
  ];
}

/**
 * Tipos principais + submotivos (reasons), como getSocorrenciaGrupoTipo no backend.
 */
export function buildDemoOccurrenceTypes(classId, idTurmaDisc) {
  if (classId && classId !== "DEMO-T1") {
    return [];
  }
  if (idTurmaDisc != null && String(idTurmaDisc) !== String(DEMO_TURMA_DISC)) {
    return [];
  }

  return [
    {
      id: "8-8",
      idGroup: 8,
      idType: 8,
      name: "Coordenação",
      icon: "supervisor_account",
      reasons: [
        {
          id: "81-8",
          idGroup: 8,
          idType: 81,
          name: "Acompanhamento pedagógico",
          icon: "trending_up",
          nivel: 3
        },
        {
          id: "82-8",
          idGroup: 8,
          idType: 82,
          name: "Conversa com responsável",
          icon: "forum",
          nivel: 3
        }
      ],
      notificationPermission: false,
      nivel: 3
    },
    {
      id: "1-10",
      idGroup: 10,
      idType: 1,
      name: "Comportamento",
      icon: "school",
      reasons: [
        { id: "2-10", idGroup: 10, idType: 2, name: "Atraso" },
        { id: "3-10", idGroup: 10, idType: 3, name: "Conversa" }
      ],
      notificationPermission: false,
      nivel: 3
    },
    {
      id: "4-20",
      idGroup: 20,
      idType: 4,
      name: "Pedagógico",
      icon: "menu_book",
      reasons: [
        { id: "5-20", idGroup: 20, idType: 5, name: "Baixo rendimento" }
      ],
      notificationPermission: false,
      nivel: 2
    },
    {
      id: "6-6",
      idGroup: 6,
      idType: 6,
      name: "Excluído da sala",
      icon: "close",
      reasons: [{ id: "61-6", idGroup: 6, idType: 61, name: "Saída da sala" }],
      notificationPermission: false,
      nivel: 1
    }
  ];
}

/**
 * Lista de alunos para lançamento (getAlunosForOccurrence + faltas/ocorrências vazias).
 */
export function buildDemoOccurrencesStudents(idTurmaDisc, scheduleId) {
  const validSchedule =
    String(scheduleId) === String(DEMO_SCHEDULE_ID_MORNING) ||
    String(scheduleId) === String(DEMO_SCHEDULE_ID_AFTERNOON);

  if (
    idTurmaDisc == null ||
    String(idTurmaDisc) !== String(DEMO_TURMA_DISC) ||
    !validSchedule
  ) {
    return [];
  }

  const isMorning = String(scheduleId) === String(DEMO_SCHEDULE_ID_MORNING);

  const students = buildDemoStudentsForClass("DEMO-T1");
  return students.map((s, i) => ({
    id: s.id,
    rollCallNum: i + 1,
    name: s.name,
    ra: s.ra,
    photo: s.photo,
    occurrences: [],
    // Demo: Ana Carolina falta na aula da manhã (tarde mostra faltante do dia).
    absence: isMorning && i === 0,
    idTurmaDisc: DEMO_TURMA_DISC,
    idSchedule: scheduleId
  }));
}
